export const IMAGE_MIME_TYPES = Object.freeze({
  PNG: 'image/png',
  JPEG: 'image/jpeg',
  JPG: 'image/jpg',
  WEBP: 'image/webp',
});

export const IMAGE_MIME_TYPE_TO_SHORT_LABEL = Object.freeze({
  [IMAGE_MIME_TYPES.PNG]: 'PNG',
  [IMAGE_MIME_TYPES.JPEG]: 'JPG',
  [IMAGE_MIME_TYPES.JPG]: 'JPG',
  [IMAGE_MIME_TYPES.WEBP]: 'WEBP',
});
